import Vue from 'vue';
import {
  GETTER_DOCTOR_LATEST_MESSAGES,
  GETTER_UNREAD_MESSAGES,
  GETTER_MESSAGES_STATE,
  ACTION_ADD_UNREAD_MESSAGE_COUNT,
  ACTION_REMOVE_UNREAD_MESSAGE_COUNT,
  ACTION_ADD_DOCTOR_LATEST_MESSAGES,
  ACTION_SET_MESSAGES_STATE,
  ACTION_CLEAR_MESSAGE_MODULE,
  MUTATE_ADD_DOCTOR_LATEST_MESSAGES,
  MUTATE_ADD_UNREAD_MESSAGE_COUNT,
  MUTATE_REMOVE_UNREAD_MESSAGE_COUNT,
  MUTATE_MESSAGES_STATE,
  MUTATE_CLEAR_MESSAGE_MODULE,
} from '@/store/types';
import {
  getSavedUnreadCount,
  saveUnreadCount,
} from '@/utils/messages';
import {
  updateStateProps,
  mutateStateProps,
} from './common-functions';

const defaultState = () => {
  return {
    /**
     * since doctor patient pair has no built-in tracking of last message unlike orders,
     * just track the last message here...
     */
    doctorLatestMessages: {},
    unread: getSavedUnreadCount(),
    fetching: false,
    initialized: false,
  };
};

const state = defaultState();

const getters = {
  [GETTER_MESSAGES_STATE]: (state) => state,
  [GETTER_DOCTOR_LATEST_MESSAGES]: ({doctorLatestMessages}) => doctorLatestMessages,
  [GETTER_UNREAD_MESSAGES]: ({unread}) => unread,
};

const actions = {
  [ACTION_SET_MESSAGES_STATE]: updateStateProps(MUTATE_MESSAGES_STATE),
  [ACTION_ADD_DOCTOR_LATEST_MESSAGES]: ({commit}, messages) => {
    commit(MUTATE_ADD_DOCTOR_LATEST_MESSAGES, messages);
  },
  [ACTION_ADD_UNREAD_MESSAGE_COUNT]: ({commit}, id) => {
    commit(MUTATE_ADD_UNREAD_MESSAGE_COUNT, id);
  },
  [ACTION_REMOVE_UNREAD_MESSAGE_COUNT]: ({commit}, id) => {
    commit(MUTATE_REMOVE_UNREAD_MESSAGE_COUNT, id);
  },
  [ACTION_CLEAR_MESSAGE_MODULE]: ({commit}) => {
    commit(MUTATE_CLEAR_MESSAGE_MODULE);
  },
};

const mutations = {
  [MUTATE_MESSAGES_STATE]: mutateStateProps,
  [MUTATE_ADD_DOCTOR_LATEST_MESSAGES]: (state, messages) => {
    Object.entries(messages).forEach(([pairToken, message]) => {
      Vue.set(state.doctorLatestMessages, pairToken, message);
    });
  },
  [MUTATE_ADD_UNREAD_MESSAGE_COUNT]: (state, id) => {
    const currentCount = state.unread[id] || 0;
    Vue.set(state.unread, id, currentCount + 1);
    saveUnreadCount(state.unread);
  },
  [MUTATE_REMOVE_UNREAD_MESSAGE_COUNT]: (state, id) => {
    Vue.set(state.unread, id, 0);
    saveUnreadCount(state.unread);
  },
  [MUTATE_CLEAR_MESSAGE_MODULE]: (state) => {
    saveUnreadCount({});
    Object.assign(state, defaultState());
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
